<template>
  <KButton
    v-if="buttonIcon"
    style="transform: scale(2.5)"
    :fill-mode="'clear'"
    @click="clickHandler"
    :svg-icon="buttonIcon"
  ></KButton>
  <KButton
    v-else
    style="transform: scale(2.5)"
    :fill-mode="'clear'"
    @click="clickHandler"
  ></KButton>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { Button as KButton } from '@progress/kendo-vue-buttons'
import { useLogger } from 'vue-logger-plugin'
import {
  heartIcon,
  userOutlineIcon,
  heartOutlineIcon
} from '@progress/kendo-svg-icons'
import type { SVGIcon } from '@progress/kendo-vue-common'
const logger = useLogger()

const props = defineProps<{
  href: string
  icon: string
}>()

logger.debug('props:', props)

const buttonIcon = ref<SVGIcon | null>(null)
if (props.icon == 'wishlist') {
  buttonIcon.value = heartOutlineIcon
} else if (props.icon == 'useraccount') {
  buttonIcon.value = userOutlineIcon
} else if (props.icon == 'heart') {
  buttonIcon.value = heartIcon
}

function clickHandler() {
  logger.debug('clickHandler')
  window.location.href = props.href
}
</script>
